/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ItemMissed = {
    properties: {
        department: {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        name: {
    type: 'string',
    isRequired: true,
},
    },
    isRequired: true,
},
        total: {
    type: 'number',
    format: 'float',
},
    },
};